import React from "react";
import { Award, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import ProgramPageLayout from "../../components/shared/ProgramPageLayout";

const SummerAcademic: React.FC = () => {
  return (
    <ProgramPageLayout slug="summer-schools" theme="blue">
      {(program) => (
        <>
          {/* Program Features from Database */}
          {program.features && program.features.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Program Features</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
                {program.features.map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 * index }}
                    className="flex items-start space-x-4 p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
                  >
                    <div className="flex-shrink-0">
                      <CheckCircle className="h-6 w-6 text-blue-500" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{feature}</h3>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          )}

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Program Overview</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Our Summer Academic Program offers students the opportunity to dive deep into academic subjects, develop critical thinking skills, and gain hands-on experience in various fields. The program combines rigorous academic coursework with engaging activities and real-world applications.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Program Features</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <Award className="h-5 w-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Intensive academic coursework in multiple subjects</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Expert instructors from top universities</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Hands-on projects and research opportunities</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">College preparation workshops</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Certificate of completion</span>
              </li>
            </ul>
          </motion.div>
        </>
      )}
    </ProgramPageLayout>
  );
};

export default SummerAcademic;

